export default __webpack_public_path__ + "static/media/promo-giphy.91981c03.png";